export const APP_ID = "rentalmanager-aceti";

export const urls = {
  documents: {
    submitted: "/documents/application-submitted",
    tenancyApplication: "/documents/tenancy-application",
  },
};
